import useQuery from "./useQuery";

export const useAuthors = (projectId?: string | undefined) => {
  const authors = useQuery("/activities/authors", {
    query: projectId ? { projectId } : {},
  }).body;

  return authors;
};
